{
  "names": {
    "Fajr": "فجر",
    "Dhuhr": "ظہر",
    "Asr": "عصر",
    "Maghrib": "مغرب",
    "Isha": "عشاء"
  },
  "card": {
    "label": "اگلی نماز",
    "labelTomorrow": "کل · {{prayer}}",
    "inHoursMinutes": "{{hours}} گھنٹے {{minutes}} منٹ میں",
    "inMinutes": "{{minutes}} منٹ میں",
    "open_aria": "نماز کے اوقات کھولیں",
    "pro": "Rhemn Pro",
    "unlock_aria": "Rhemn Pro کے ساتھ نماز کے اوقات کھولیں",
    "unavailable": "نماز کے اوقات فی الحال دستیاب نہیں ہیں۔"
  },
  "sheet": {
    "bellOn_aria": "{{prayer}} کی یاد دہانی بند کریں",
    "bellOff_aria": "{{prayer}} کی یاد دہانی آن کریں",
    "explainer": "ہر نماز پر ایک نرم یاد دہانی حاصل کریں۔ یاد دہانیاں خاموش اطلاعات ہیں — بطورِ طے شدہ کوئی آواز نہیں۔",
    "enableReminders": "یاد دہانیاں فعال کریں",
    "enableInSettings": "نماز کی یاد دہانیاں پانے کے لیے ترتیبات میں Rhemn کی اطلاعات آن کریں۔",
    "openSettings": "ترتیبات کھولیں"
  },
  "notifications": {
    "body": "نماز کا وقت ہو گیا ہے۔"
  },
  "focus": {
    "label": "نمازِ {{prayer}}",
    "close_aria": "نماز اسکرین بند کریں",
    "hint": "واپس جانے کے لیے Esc یا × دبائیں",
    "phrases": {
      "accepted": "اللہ آپ کی نماز قبول فرمائے",
      "acceptedAr": "تقبّل الله صلاتك"
    }
  },
  "ambient": {
    "default": "نیت سے آغاز کریں۔ برکت کے ساتھ جاری رکھیں۔",
    "prayerApproaches": "آپ کی اگلی نماز قریب ہے۔ اپنی نیت پر قائم رہیں۔",
    "morningPursue": "ایک بابرکت صبح اس کے لیے: {{focus}}",
    "dayCloses": "جیسے دن ڈھل رہا ہے، اس پر غور کریں: {{focus}}",
    "fulfilled": "آپ نے آج اپنی نیت پوری کی۔ الحمدللہ۔",
    "workingTowards": "آج آپ اس کی طرف کوشاں ہیں: {{focus}}",
    "prayerNear": "آپ کی اگلی نماز قریب ہے۔ ایک سانس لیں۔"
  },
  "widget": {
    "countdown": "{{time}} میں",
    "openToUpdate": "اپڈیٹ کے لیے Rhemn کھولیں",
    "openForVerse": "آج کی آیت کے لیے Rhemn کھولیں"
  }
}
